"use client";

import Image from "next/image";
import { Heading, Text } from "@/components/ui/typography";

const cards = [
  {
    id: 1,
    title: "Global-First Structuring",
    desc: "Built specifically for online businesses operating internationally.",
    icon: "/building-fill.svg",
    size: 65,
  },
  {
    id: 2,
    title: "End-to-End Coordination",
    desc: "From setup to ongoing compliance, everything stays organized under one structure.",
    icon: "/doc.svg",
    size: 65,
  },
  {
    id: 3,
    title: "Remote & Digital Process",
    desc: "Handle documentation and setup from anywhere in the world.",
    icon: "/tax.svg",
    size: 65,
  },

  {
    id: 5,
    title: "Built Around Growth",
    desc: "Your structure should support scaling, not slow it down.",
    icon: "/audit.svg",
    size: 65,
  },
];

export default function LicenseSection({ heading = "Why Founders Choose MuteTaxes" }: { heading?: string } = {}) {
  return (
    <section className="bg-black md:py-[60px] py-[30px] px-4">
      <div className="max-w-[1200px] mx-auto flex flex-col gap-10">
        {/* TITLE */}
        <div>
          <Heading as="h2" variant="sectionCentered">
            {heading}
          </Heading>
        </div>

        {/* GRID (50% / 50%) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {cards.map((card) => (
            <div
              key={card.id}
              className="bg-[#0f1218] border border-white/10 rounded-2xl p-6 md:px-10 md:py-[24px] flex gap-6 items-center"
            >
              {/* ICON */}
              <div
                className="relative flex-shrink-0"
                style={{
                  width: card.size,
                  height: card.size,
                }}
              >
                <Image
                  src={card.icon}
                  alt={card.title}
                  fill
                  // flat near-black artwork (verified) — invert to white
                  className="object-contain [filter:brightness(0)_invert(1)]"
                />
              </div>

              {/* CONTENT */}
              <div className="flex flex-col gap-2">
                <Heading as="h3" variant="cardTitle" className="text-[18px] md:text-[20px] leading-[120%]">
                  {card.title}
                </Heading>
                <Text variant="muted" size="sm" className="md:text-[16px] leading-[150%]">
                  {card.desc}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
